<template>
  <v-dialog
    @keydown.esc="$emit('input', null)"
    content-class="dialog-fixed-top"
    :value="isVisible"
    @input="v => v || $dismiss()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="600">

    <v-card>
      <v-card-title class="card-bar">Colunas</v-card-title>

      <OMultiSelectList :rows="fullSpec.columns"
        :value="selectedCodes"
        keyProp="code" hideRight class="maxh-4">
        <template v-slot="{row}">{{row.title}}</template>
      </OMultiSelectList>

      <v-card-actions class="pa-6">
        <v-btn text large
          @click="$dismiss()">Cancel</v-btn>
        <v-spacer/>
        <v-btn text large color="primary"
          @click="apply()">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import {fullSpec} from './client-columns'

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    OMultiSelectList: require('oderon-vue/cpts/OMultiSelectList').default,
  },
  data() {
    return { selectedCodes: [], fullSpec }
  },
  methods: {
    open(currentCodes) {
      this.selectedCodes = _.clone(currentCodes)
      return this.$open()
    },
    apply() {
      this.$apply(this.selectedCodes)
    }
    // toggle(x) {
    //   let idx = this.currentCodes.indexOf(x)
    //   if ( idx != -1 ) {
    //     this.$delete(this.selected, idx)
    //   } else {
    //     this.selected.push(x)
    //   }
    // }
  }
}
</script>

<style>
</style>
